import { IVideoFile } from '../videoInterface';

export const enum ModuleName {
  YES_NO = 'YES_NO',
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
  SINGLE_CHOICE = 'SINGLE_CHOICE',
  FREE_TEXT = 'FREE_TEXT',
  LOCATION = 'LOCATION',
  DATE = 'DATE',
  EMAIL = 'EMAIL',
  PHONE_NUMBER = 'PHONE_NUMBER',
  FILE_UPLOAD = 'FILE_UPLOAD',
  URL = 'URL',
  NUMBER = 'NUMBER',
  DROPDOWN = 'DROPDOWN',
  WIDGET = 'WIDGET',
  SCHEDULE = 'SCHEDULE',
  MATRIX_CHOICE = 'MATRIX_CHOICE',
  AVAILABILITY = 'AVAILABILITY',
  ID_ANALYZER = 'ID_ANALYZER',
  THANK_YOU = 'THANK_YOU',
  REJECT = 'REJECT'
}

export const enum QuestionType {
  TEXT_ONLY = '',
  IMAGE = 'image',
  VIDEO = 'video',
}

export const enum DateFormat {
  GBR = 'DD/MM/YYYY',
  US = 'MM/DD/YYYY',
}

export enum DocumentType {
  Passport = 'P',
  DriversLicense = 'D',
  IdentityCard = 'I',
}

export type QuestionMedia = {
  questionType?: QuestionType;
  questionUrl?: string;
};

export type GenericConfig = {
  title: string;
  description: string;
  required?: boolean;
  questionMedia?: QuestionMedia;
  audio_url?: string;
};

export type GenericOption = {
  id: string;
  title: string;
  selected: boolean;
};

export type Question = {
  id: string;
  title: string;
  selectAllTitle?: string;
  answers: GenericOption[];
};

export type TextAnswer = { answer: string };

export type Options<T> = { options: GenericOption[] } & T;

export type Questions<T> = { questions: (Question & T)[] };

export type SingleSelect = Options<{ selected_id: GenericOption['id'] }>;

export type MultiSelect = Options<{ selected_ids: GenericOption['id'][], maxSelected: number, minSelected: number }>;

export type MultiAnswerQuestions = Questions<{ selected_ids: GenericOption['id'][] }>;

export type DateFormatData = { format: DateFormat };

export type FileData = { filename: string };

export type IDAnalayzerDagta = {
  passed : boolean,
  result : {
    face : boolean,
    notexpired : boolean
  },
  authentication : Record<string, unknown>,
  success : boolean,
  firstName: string,
  lastName: string,
  expiry: string,
  daysToExpiry : number,
  issued: string,
  daysFromIssue : number,
  issuerOrg_full: string,
  documentType: string
}

export type ScheduleData = {
   start: string;
   end: string;
   meeting_id: string;
};

export type WidgetData = {
  videos: IVideoFile[];
}

export type EmptyObject = Record<never, never>;

export type ModuleDataAnswer =
| TextAnswer
| SingleSelect
| MultiSelect
| MultiAnswerQuestions
| DateFormatData
| IDAnalayzerDagta
| ScheduleData
| WidgetData;

export type Module<N extends ModuleName, D extends ModuleDataAnswer | EmptyObject = EmptyObject> = {
  id: string;
  name: N;
  type: string;
  completed: boolean;
  data: GenericConfig & D;
};
